module.exports = __webpack_public_path__ + "img/忠县重庆皇华岛国家湿地公园@2x.ca233bff.png";